import { inject, Injectable } from '@angular/core';
import { PlatformService } from '@sml/utility';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private platformService = inject(PlatformService);

  private readonly spinnerVisible$ = new Subject<boolean>();

  public showSpinner(): void {
    this.spinnerVisible$.next(true);
  }

  public hideSpinner(): void {
    if(this.platformService.browser()){
      this.spinnerVisible$.next(false);
    }
  }

  public getSpinerState(): Observable<boolean> {
    return this.spinnerVisible$.asObservable();
  }
}